import { jsx as _jsx } from "react/jsx-runtime";
import { ConsentElementMarker } from './consent_element_marker.component';
export const ConsentElementOverlay = ({ pageNumber, elements, onUpdateElement, onDeleteElement, onConfigureElement, }) => {
    const pageElements = elements.filter((el) => el.page === pageNumber);
    return (
    // never intercept pointer events — the parent page-wrapper handles placement clicks
    _jsx("div", { "data-testid": `consent-overlay-page-${pageNumber}`, style: {
            position: 'absolute',
            inset: 0,
            zIndex: 10,
            pointerEvents: 'none',
        }, children: pageElements.map((el) => (
        // re-enable pointer events just for the markers so they stay interactive
        _jsx("div", { style: { pointerEvents: 'auto' }, children: _jsx(ConsentElementMarker, { element: el, onUpdate: onUpdateElement, onDelete: onDeleteElement, onConfigureClick: onConfigureElement }) }, el.id))) }));
};
